import { AT } from './actionTypes';
import { Feedback } from '../interfaces';
import { store } from '../index';
import Logger from '../libs/logger'; 
import { LogArea } from '../libs/logger/const';

export const feedbackSeen = (feedback: Feedback) => {
  Logger.info('ActionSeen', LogArea.Feedback);
  const action = {
    type: AT.FEEDBACK_SEEN,
    payload: feedback,
  };

  store.dispatch(action);
};

export default feedbackSeen;
